import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import { Route, Routes } from 'react-router';
import { useSocket } from '@connect-x-app/hybrid-state';
import { useInternetConnection } from '@connect-x-app/shared-utils';
import { AppAdmin } from '@connect-x-app/web-shell-admin';
import { AppWeb } from '@connect-x-app/web-shell-web';
import { clearToast, ModalWrapper, Toastify, toastWarning } from '@connect-x-app/web-ui';
import { Socket } from 'socket.io-client';
import DisconnectReason = Socket.DisconnectReason;

const OFFLINE_TOAST_ID = 'offline-toast';

Modal.setAppElement('#root');

export const App: FC = () => {
  const { connectSocket, socket } = useSocket();
  const { isInternetConnectionOffline } = useInternetConnection();
  const { t } = useTranslation();

  useEffect(() => {
    if (isInternetConnectionOffline) {
      toastWarning(t('ERRORS.CONNECTION.INTERRUPTED'), { autoClose: false, toastId: OFFLINE_TOAST_ID });
      return;
    }
    clearToast(OFFLINE_TOAST_ID);
  }, [isInternetConnectionOffline, t]);

  useEffect(() => {
    const onDisconnect = (reason: DisconnectReason) => {
      if (reason !== 'io client disconnect') {
        // eslint-disable-next-line no-console
        console.error(`Socket disconnect: ${reason}`);
      }
      if (reason === 'io server disconnect') {
        // Server-initiated disconnect stops Socket.io auto-reconnect; restart it manually
        connectSocket();
      }
    };

    socket?.on('disconnect', onDisconnect);

    return () => {
      socket?.off('disconnect', onDisconnect);
    };
  }, [connectSocket, socket]);

  return (
    <>
      <Routes>
        <Route element={<AppWeb />} path="*" />
        <Route element={<AppAdmin />} path="/admin/*" />
      </Routes>
      <ModalWrapper />
      <Toastify />
    </>
  );
};
